import _sfc_main from "./YearView.vue2.js";
/* empty css              */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const YearView = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-3fab8944"]]);
export {
  YearView as default
};
//# sourceMappingURL=YearView.vue.js.map
